const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  error: (...args) => { if (isDev) console.error('[Vayu]', ...args); },
  warn: (...args) => { if (isDev) console.warn('[Vayu]', ...args); },
  info: (...args) => { if (isDev) console.info('[Vayu]', ...args); },
};

export default logger;
